import styled from "styled-components";
import { buttonColor, fadingTextColor } from "../../styles/styles";
import { Flex } from "antd";

export const GradientContainer = styled(Flex)`
  align-items: center;
  justify-content: center;
  padding: 0.5vw;
`;

export const AcademyContainer = styled("div")`
  margin-bottom: 1rem;
`;

export const AcademyTitle = styled("h5")`
  margin-bottom: 0.4rem;
`;

export const FlexContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ProjectContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Badge = styled.span`
  background-color: #5d65af;
  padding: 0.125rem 0.5rem;
  color: white;
`;

export const BottomProjectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Status = styled("h6")`
  border: 1px solid #e5e7eb;
  padding: 0.25rem;
  align-self: flex-start;
`;

export const ProductTitle = styled.h2`
  font-size: 1.875rem;
`;

export const ApproachFlexContainer = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ApproachSpan = styled.span`
  padding: 0.125rem 0.35rem;
  background-color: ${buttonColor};
`;

export const NumberBudgetTitle = styled.h2`
  font-size: 1.875rem;
`;

export const SubtitleBudget = styled.h3`
  font-size: 1.125rem;
`;

export const SocialTitle = styled("h5")`
  font-weight: 400;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.6em;
  }
`;

export const SocialText = styled("p")`
  color: ${fadingTextColor};
  font-size: 0.9em;
  margin-top: 0.8vw;
`;

export const SocialImg = styled("img")`
  width: 16vw;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 38vw;
  }
`;

export const PostsH = styled("h5")`
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 1.2em;
  }
`;

export const GuyStyle = styled("img")`
  width: 4vw;
  display: block;
  height: 4vw;
  
  object-fit: cover;
  border-radius: 50%;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 10vw;
    height: 10vw;
  }
`;

export const GoodImage = styled("img")`
  height: 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: 14px;
  }
`;
